const SYNTHETIC_REPORTER_SPACES = new Set(["melissanthis-farm"]);
const SYNTHETIC_QA_REPORTER_EMAIL =
  /^qa-(?:tester|buyer|champion|learner|admin)-farm-\d+@mindstone\.com$/i;

export function canShowControlledBugReport({
  isStaff,
  reporterEmail,
  mindspaceUniqueName,
}: {
  isStaff: boolean;
  reporterEmail?: string | null;
  mindspaceUniqueName?: string | null;
}) {
  // This is only an affordance hint. The server independently verifies the
  // mindspace's synthetic context, designated QA identity, and membership.
  // Persona accounts never receive the reporting action, including locally.
  return (
    isStaff ||
    (SYNTHETIC_REPORTER_SPACES.has(mindspaceUniqueName ?? "") &&
      SYNTHETIC_QA_REPORTER_EMAIL.test(reporterEmail?.trim() ?? ""))
  );
}
